import styled from 'styled-components/macro'
import { rem } from '../../utils/styles'
import Button from '../Button'

const PaneActions = styled.footer`
  display: flex;
  flex-direction: row-reverse;

  ${Button} + ${Button} {
    margin-right: ${rem(15)};
  }
`

export default PaneActions
